export default {
    API: process.env.VUE_APP_API,
    SITEKEY: process.env.VUE_APP_RECAPTCHA_SITEKEY
}